import axios from "axios";

const RAW_BASE =
    import.meta.env?.VITE_API_URL ??
    import.meta.env?.VITE_API_BASE_URL ??
    "https://api.idlogichain.com";

const BASE_URL = RAW_BASE.replace(/\/+$/, "");

if (BASE_URL.endsWith("/api")) {
    console.error("VITE_API_URL must be without /api");
}

const getToken = () =>
    localStorage.getItem("authToken") ||
    sessionStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    localStorage.getItem("jwt");

export const api = axios.create({
    baseURL: `${BASE_URL}/api`,
    headers: {
        "Content-Type": "application/json",
    },
});

export const authApi = axios.create({
    baseURL: `${BASE_URL}/api`,
    headers: {
        "Content-Type": "application/json",
    },
});

export const publicApi = axios.create({
    baseURL: `${BASE_URL}/api`,
    headers: {
        "Content-Type": "application/json",
    },
});

const attachToken = (config) => {
    const token = getToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
};

api.interceptors.request.use(attachToken);
authApi.interceptors.request.use(attachToken);

export default api;